<template>
  <div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-md-5 col-lg-6 col-xl-4 px-lg-6 my-5 align-self-center">
          <div>
            <img v-if="$store.state.darkMode" src="../assets/logo.png" style="width:250px" class="mx-auto d-block mb-3" alt="aqfer logo" />
            <img v-else src="../assets/logo2.png" style="width:250px" class="mx-auto d-block mb-3" alt="aqfer logo" />
          </div>

          <p class="text-muted text-center">Client and Administration Portal</p>
          <p class="text-center mb-4"><small class="text-muted">Signing in to <strong>{{ cid }}</strong></small></p>

          <button id="login-btn-org" @click="loginClicked" class="btn btn-lg w-100 btn-primary mb-3" :disabled="isClicked">
            <div v-if="isClicked" class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <span v-else>
              <i class="fa fa-building me-3"></i>
              Sign in with Organization
            </span>
          </button>

          <p class="text-center">
            <small class="text-muted text-center">
              <router-link to="/login">Not your organization? Use a different sign-in method.</router-link>
            </small>
          </p>

          <p class="text-center">
            <small class="text-muted text-center">
              Need Access? Contact us at <a href="mailto:support@aqfer.com">support@aqfer.com</a>.<br />
              Version {{ appVersion }}
            </small>
          </p>
        </div>
        <div class="col-12 col-md-7 col-lg-6 col-xl-8 d-none d-lg-block">
          <div class="bg-cover h-100 min-vh-100 mt-n1 me-n3" :style="{
            'background-image': 'url(' + require('../assets/back2.jpg') + ')',
          }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CidLogin",
  data() {
    return {
      isClicked: false,
      appVersion: process.env.VUE_APP_VERSION
    }
  },
  computed: {
    cid() {
      return this.$route.params.cid;
    }
  },
  mounted() {
    if (this.cid) {
      localStorage.setItem('cidLogin', this.cid);
    }
  },
  methods: {
    loginClicked() {
      this.isClicked = true;
      this.$store.dispatch('cidLogin', this.cid);
    }
  }
};
</script>
